import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { useHTTP } from 'hooks/useRequest';
import { WarningTriangle } from 'assets/icons';
import toRem from 'utils/toRem';
import responsive from 'utils/responsive';
import { gaMFADisabled } from 'data_layer/ga_authentication_events';

const MFAOptOutModal = ({ modalOpen, closeModal }) => {
  const [dismissConfirmed, setDismissedConfirmed] = useState(false);

  const mfaOptOutRequestConfig = {
    method: 'POST',
    url: dismissConfirmed ? '/mfa/confirm_disable' : null,
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    },
  };

  const { data: mfaOptOutResponse, loading } = useHTTP(
    mfaOptOutRequestConfig || null,
  );

  useEffect(() => {
    setDismissedConfirmed(false);

    if (mfaOptOutResponse?.success) {
      gaMFADisabled();
      window.location.href = mfaOptOutResponse?.url;
    }
  }, [mfaOptOutResponse]);

  return (
    <StyledModal isOpen={modalOpen} closeModal={closeModal}>
      <div className="fl">
        <div className="mr-12">
          <WarningTriangle width={28} height={26} />
        </div>

        <div>
          <ModalHeading className="ff-body fs-22 tc-main fw-600 lh-1-2 mb-16 mt-0">
            Are you sure you want to turn off two-factor authentication?
          </ModalHeading>

          <p className="ff-body fs-16 m-fs-16 tc-secondary lh-1-3">
            After turning off two-factor authentication, a verification code
            will no longer be required to sign in to your account.
          </p>
        </div>
      </div>

      <div className="fl fl-row-reverse jc-fs ai-c g-16 mt-32">
        <ModalButton
          type="button"
          handleClick={() => setDismissedConfirmed(true)}
          label="Get Started"
          className="cef-btn cef-btn--red cef-btn--feature cef-ui__button width-50">
          {loading ? <span className="cef-btn__loader bs-bb" /> : 'Turn Off'}
        </ModalButton>

        <ModalButton
          type="button"
          handleClick={closeModal}
          label="Dismiss"
          className="cef-btn cef-btn--grey cef-btn--feature cef-ui__button width-50">
          Cancel
        </ModalButton>
      </div>
    </StyledModal>
  );
};

const StyledModal = styled(Modal)`
  > div {
    padding: ${toRem(32)} ${toRem(16)};
    width: 80%;
    max-width: 500px;
    box-sizing: border-box;

    ${responsive('tabletSmall')} {
      padding: ${toRem(32)} ${toRem(32)};
    }
  }
`;

const ModalButton = styled(Button)`
  max-width: 164px;
`;

// Overriding default MyCEF styles
const ModalHeading = styled.h3`
  .container & {
    background-color: transparent;
    padding-left: 0;
  }
`;

export default MFAOptOutModal;
